<template lang="pug">
div.small-space
  .label.is-small {{initBlock.config.label}}
  vue-editor(:value="initBlock.value.text" @input="updateValue" :editorOptions="editorOptions")
</template>

<script>
export default {
  props: {
    parentKey: String,
    initBlock: {
      type: Object,
      default() {
        return {
          value: {
            text: null
          },
          config: null
        }
      }
    }
  },
  data() {
    return {
      editorOptions: {
        placeholder: "Bitte füllen Sie dieses Feld aus ...",
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike", "link"], // toggled buttons
            ["blockquote"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ color: [
              '#22C55E', "#EF4444", '#ffd17f', '#3182CE', '#ffffff', '#000000', 'gray'
            ] }, { background: [
              '#BBF7D0', "#FECACA", '#fff4df', '#90CDF4', 'lightgray'
            ] }], // dropdown with defaults from theme
            [{ align: [] }],
            ["clean"] // remove formatting button
          ]
        }
      }
    };
  },
  methods: {
    updateValue(e) {
      if (e === this.initBlock.value.text) return;
      this.$root.$emit('updateBlockJSON', {
        name: this.initBlock.name,
        key: this.initBlock.key,
        parentKey: this.parentKey,
        value: {
          text: e
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.small-space {
  margin-bottom: 16px;
}
</style>